import { gateway } from "../../../gateway";
import { IEventDeliveryConfig, IUpdateEventDeliveryConfigPayload } from "../interfaces";

export const updateEventDeliveryConfig = async (payload: IUpdateEventDeliveryConfigPayload): Promise<IEventDeliveryConfig> => {
  const response = await gateway.put("/event-delivery/config", payload);
  return response?.data?.data;
};

